function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'components/Form/Button';
import Pagination from 'components/Pagination';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './ImportPatientDatabase.pcss';
var _React_PureComponent;
class ImportErrorsList extends (_React_PureComponent = React.PureComponent) {
    onPageChange(page) {
        this.setState({
            page
        });
    }
    renderError(error) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.errorsList__item,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-7",
                        children: [
                            error.firstName,
                            " ",
                            error.lastName
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-5",
                        children: error.id
                    })
                ]
            })
        }, error.id);
    }
    renderPagination() {
        const { errorsList } = this.props;
        const { page } = this.state;
        const totalPages = Math.ceil(errorsList.length / this.perPage);
        return /*#__PURE__*/ _jsx(Pagination, {
            perPage: this.perPage,
            onPageChange: (p)=>this.onPageChange(p),
            page: page,
            totalPages: totalPages,
            isPerPageOff: true
        });
    }
    render() {
        const { page } = this.state;
        const errorsListPage = this.props.errorsList.slice(this.perPage * page, this.perPage * (page + 1));
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.errorsList__item,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row text--bold",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-7",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.patient))
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-5",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.patientId))
                                    })
                                ]
                            })
                        }),
                        errorsListPage.map((error)=>this.renderError(error))
                    ]
                }),
                this.renderPagination(),
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-6",
                        children: /*#__PURE__*/ _jsx(Button, {
                            styleModifier: "primary",
                            labelMessage: messages.buttons.back,
                            className: "btn--block btn--filled mt-4",
                            onClick: ()=>this.props.onSetComponent('ImportPatientDatabase')
                        })
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.perPage = 10;
        this.state = {
            page: 0
        };
    }
}
_define_property(ImportErrorsList, "propTypes", {
    // Explicit actions
    onSetComponent: PropTypes.func,
    // Implicit props
    errorsList: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string
    }))
});
const mapStateToProps = (state)=>({
        errorsList: selectors.importPatientDatabaseErrorsList(state)
    });
const ConnectedImportErrorsList = connect(mapStateToProps)(ImportErrorsList);
export default withStyles(styles)(ConnectedImportErrorsList);
